var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1582_19697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 2.625C17.0168 2.625 19.9101 3.82343 22.0433 5.95666C24.1766 8.08989 25.375 10.9832 25.375 14C25.375 17.0168 24.1766 19.9101 22.0433 22.0433C19.9101 24.1766 17.0168 25.375 14 25.375C10.9832 25.375 8.08989 24.1766 5.95666 22.0433C3.82343 19.9101 2.625 17.0168 2.625 14C2.625 10.9832 3.82343 8.08989 5.95666 5.95666C8.08989 3.82343 10.9832 2.625 14 2.625ZM14 28C17.713 28 21.274 26.525 23.8995 23.8995C26.525 21.274 28 17.713 28 14C28 10.287 26.525 6.72601 23.8995 4.10051C21.274 1.475 17.713 0 14 0C10.287 0 6.72601 1.475 4.10051 4.10051C1.475 6.72601 0 10.287 0 14C0 17.713 1.475 21.274 4.10051 23.8995C6.72601 26.525 10.287 28 14 28ZM13.6008 13.9781C13.7211 14.0438 13.8578 14.082 14 14.082C14.1422 14.082 14.2789 14.0492 14.3992 13.9781L20.9945 10.3469C20.918 9.45547 20.1633 8.75 19.25 8.75H8.75C7.83672 8.75 7.08203 9.45547 7.00547 10.3523L13.6008 13.9836V13.9781ZM15.2414 15.5094C14.8586 15.7172 14.432 15.8266 14 15.8266C13.568 15.8266 13.1359 15.7172 12.7586 15.5094L7 12.343V17.5C7 18.468 7.78203 19.25 8.75 19.25H19.25C20.218 19.25 21 18.468 21 17.5V12.343L15.2414 15.5094Z",
    fill: "#5F6F7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1582_19697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.3cc6061337612181f163a256b16d8c03.svg";
export { ForwardRef as ReactComponent };